import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link, useParams } from 'react-router-dom';
import MeasurementUnitForm from '../../Components/MeasurementUnits/MeasurementUnitForm';
import { withNamespaces } from 'react-i18next';

/**
 * Component for editing an existing measurement unit
 * @returns {JSX.Element}
 */
const MeasurementUnitEdit = (props) => {
  const { t } = props;
  const { lng, id } = useParams();

  return (
    <Container fluid>
      <Row className="top-header-box mx-1 columnList">
        <Col>
          <h2 className="text-title">{t('measurementUnits.form.editTitle')}</h2>
          <p className="text-muted" style={{ margin: 0 }}>{t('measurementUnits.tab.cards.editUnit.description')}</p>
        </Col>
        <Col xs="auto" className="d-flex align-items-center">
          <Link to={`/${lng}/settings/measurement-units`} className="btn btn-secondary">
            <FontAwesomeIcon icon={faArrowLeft} className="me-2" /> {t('measurementUnits.list.backToList')}
          </Link>
        </Col>
      </Row>

      <MeasurementUnitForm isEdit={true} slack={id} />
    </Container>
  );
};

export default withNamespaces()(MeasurementUnitEdit);
